import { render, staticRenderFns } from "./systemMsg.vue?vue&type=template&id=7467cca2"
import script from "./systemMsg.vue?vue&type=script&lang=js"
export * from "./systemMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports